(function () {
  'use strict';
  if (window.h13DenimPairLoaded) return;
  window.h13DenimPairLoaded = true;

  function init(scope) {
    (scope || document).querySelectorAll('[data-denim-pair]').forEach(function (section) {
      if (section.dataset.pairReady) return;
      var form = section.querySelector('[data-pair-form]');
      var selects = Array.from(section.querySelectorAll('[data-pair-variant]'));
      var button = section.querySelector('[data-pair-submit]');
      var status = section.querySelector('[data-pair-status]');
      var strings;
      try { strings = JSON.parse(section.querySelector('[data-pair-strings]').textContent); }
      catch (error) { return; }
      if (!form || selects.length !== 2 || !button) return;
      section.dataset.pairReady = 'true';
      var busy = false;
      var discount = section.dataset.offerActive === 'true' ? Number(section.dataset.discount) || 0 : 0;
      var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: section.dataset.currency || 'USD'
      });
      function format(cents) { return money.format(cents / 100); }
      function selected() { return selects.map(function (select) { return select.options[select.selectedIndex]; }); }
      function update() {
        var options = selected();
        var available = options.every(function (option) { return option && option.dataset.available === 'true'; });
        var total = options.reduce(function (sum, option) { return sum + Number(option ? option.dataset.price : 0); }, 0);
        options.forEach(function (option, index) {
          if (!option) return;
          var card = selects[index].closest('.denim-pair__product');
          var price = Number(option.dataset.price);
          var compare = Number(option.dataset.compare);
          card.querySelector('[data-pair-price]').textContent = format(price);
          var comparison = card.querySelector('[data-pair-compare]');
          comparison.hidden = compare <= price;
          comparison.textContent = format(compare);
        });
        var offeredTotal = Math.max(0, total - discount);
        section.querySelector('[data-pair-total]').textContent = format(offeredTotal);
        var original = section.querySelector('[data-pair-original]');
        if (original) original.textContent = format(total);
        section.querySelector('[data-pair-benefit]').textContent = section.dataset.country === 'US' && section.dataset.currency === 'USD'
          ? (offeredTotal >= 7500 ? strings.freeShipping : strings.standardShipping)
          : strings.internationalShipping;
        button.disabled = busy || !available;
        button.textContent = busy ? strings.adding : available ? strings.add : strings.unavailable;
        return available;
      }
      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          status.hidden = true;
          update();
        });
      });
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy || !update()) return;
        var items = selects.map(function (select) { return { id: Number(select.value), quantity: 1 }; });
        busy = true;
        status.hidden = true;
        form.setAttribute('aria-busy', 'true');
        selects.forEach(function (select) { select.disabled = true; });
        update();
        try {
          if (typeof window.h13CartAdd === 'function') {
            var ok = await window.h13CartAdd(items, true);
            if (!ok) throw new Error(strings.error);
          } else {
            var response = await fetch(form.action + '.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            });
            var result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || strings.error);
            window.location.assign((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart');
          }
          status.textContent = strings.added;
          status.hidden = false;
        } catch (error) {
          status.textContent = error.message || strings.error;
          status.hidden = false;
          status.setAttribute('tabindex', '-1');
          status.focus();
        } finally {
          busy = false;
          form.removeAttribute('aria-busy');
          selects.forEach(function (select) { select.disabled = false; });
          update();
        }
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('h13:navigated', function () { init(document); });
})();
